<template>
    <div>
        <index>

            <div class="card">
                <div class="card-body">
                    <div class="card card-body info-card" style="font-weight: normal;">
                        Thanks for applying. You will be contacted shortly for an interview at our office
                    </div>
                </div>
            </div>
        </index>
    </div>
</template>

<script>
    import Index from "./Index";

    export default {
        components: {Index},
        name: "status"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Pages/Profile/Status.vue